<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="主单号">
                <el-input v-model="formInline.orderMainNo" placeholder="请输入主订单号" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getUnsyncEDBOrders">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="syncEdbOrder()">全部同步至OMS</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="unsyncOrderList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="主订单号" width="170">
                <template slot-scope="scope">
                    <a :href="`//erpnew.lechun.cc/admin_sold_show.html?SOLD_ID=${scope.row.ORDER_MAIN_NO}`" target="_blank"  class="order-main-num">{{ scope.row.ORDER_MAIN_NO }}</a>
                    <span style="margin-left: 10px"></span>
                </template>
            </el-table-column>
            <el-table-column prop="ORDER_NO" label="子订单号">
            </el-table-column>
            <el-table-column prop="PICKUP_TIME" label="提货日期" width="150"></el-table-column>
            <el-table-column prop="CREATE_TIME" label="创单时间" width="150"></el-table-column>
            <el-table-column prop="ORDER_CLASS" label="订单类型" width="150"></el-table-column>
            <el-table-column prop="ORDER_SOURCE" label="订单来源" width="150"></el-table-column>
            <el-table-column prop="MAIN_STATUS" label="主订单状态" width="150"></el-table-column>
            <el-table-column prop="SUB_STATUS" label="子订单状态" width="150"></el-table-column>
            <el-table-column prop="DELIVER_COUNT" label="总配送次数" width="150"></el-table-column>
            <el-table-column prop="PS_TIMES" label="第几次配送" width="150"></el-table-column>
            <el-table-column label="操作" fixed="right" >
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="syncEdbOrder(scope.row.ORDER_MAIN_NO)">同步</el-button>
                    <el-button type="success" size="mini" @click="syncStatusEdbOrder(scope.row.ORDER_MAIN_NO)">同步支付成功</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {omsOrderSyncQuartz,omsOrderSyncStatus, unsyncOMSOrders} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                    orderMainNo: ''
                },
                showDialog: false,
                loading: true,
                unsyncOrderList: []// 活动列表
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getUnsyncEDBOrders();
        },
        methods: {
            getUnsyncEDBOrders(){
                this.loading = true;
                unsyncOMSOrders(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.unsyncOrderList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            syncEdbOrder(orderMainNo){
                omsOrderSyncQuartz({'orderMainNo':orderMainNo}).then((res) => {
                    this.loading = true;
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getUnsyncEDBOrders();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            syncStatusEdbOrder(orderMainNo){
                omsOrderSyncStatus({'orderMainNo':orderMainNo}).then((res) => {
                    this.loading = true;
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getUnsyncEDBOrders();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getUnsyncEDBOrders();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getUnsyncEDBOrders();
            }
        }
    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/views/order/UnsyncedOMSOrders.vue